import { UseLoadingReturn } from "@/hooks/use-loading";
import campaignImageService from "@/services/campaign-image.service";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type UseRemoveCampaignImageReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveCampaignImage = (): UseRemoveCampaignImageReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (imageId) => campaignImageService.delete(imageId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveCampaignImage;
